import { useState } from "react";
import  { useArchiveContext} from '../../context/archive.context'

export const SearchField = ({ handleSearchField, homeSearchQuery }) => {
	const [search, setSearch] = useState(homeSearchQuery || "");

	const { lang } = useArchiveContext();

	const isArabic = lang.toLowerCase().includes("ar");

	function handleSearch(e) {
		setSearch(e.target.value);
		// handleSearchField(e.target.value);
	}

	function handleClose(e) {
		setSearch("");
		handleSearchField("");
	}

	function handleEnter({ code, target }) {
		if (code !== "Enter") return;

		handleSearchField(target.value);
	}

	return (
		<div
			className="
MuiGrid-root
homeSearchBar-42
fadeIn-7
fix
MuiGrid-item MuiGrid-grid-xs-12
"
		>
			<div className="search-43">
				<div
					className="
        MuiFormControl-root
        MuiTextField-root
        active
    "
				>
					<div
						className="
            MuiInputBase-root
            MuiOutlinedInput-root
            MuiInputBase-formControl
        "
					>
						<input
							value={search}
							onChange={handleSearch}
							onKeyDown={handleEnter}
							type="text"
							aria-invalid="false"
							id="outlined-basic"
							className="
                MuiInputBase-input
                MuiOutlinedInput-input
                search-input
            "
							required
						/>
						<label
							className="label"
							for="outlined-basic"
							id="outlined-basic-label"
						>
						{isArabic ? `أنا أبحث عن معلومات حول` : 'I am looking for information about'}	
						</label>
					</div>
				</div>

				<div className="clearInputSearch-48 active">
					<svg
						onClick={handleClose}
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M19.3327 2.54675L17.4527 0.666748L9.99935 8.12008L2.54602 0.666748L0.666016 2.54675L8.11935 10.0001L0.666016 17.4534L2.54602 19.3334L9.99935 11.8801L17.4527 19.3334L19.3327 17.4534L11.8793 10.0001L19.3327 2.54675Z"
							fill="#201F57"
						/>
					</svg>
				</div>

				<div
					className="searchButton-49 active"
					style={{ position: "absolute", top: 1, bottom: 1 }}
					onClick={() => handleSearchField(search)}
				>
					<svg
						width="28"
						height="28"
						viewBox="0 0 28 28"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className="search-icon"
					>
						<path
							d="M20.2489 11.4382C20.2489 16.5008 16.1448 20.6048 11.0822 20.6048C6.01958 20.6048 1.91553 16.5008 1.91553 11.4382C1.91553 6.37554 6.01958 2.27148 11.0822 2.27148C16.1448 2.27148 20.2489 6.37554 20.2489 11.4382Z"
							stroke="white"
							stroke-width="3"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M26 26L18 18"
							stroke="white"
							stroke-width="3"
							stroke-linejoin="round"
						/>
					</svg>
					<svg
						width="58"
						height="57"
						viewBox="0 0 58 57"
						fill="red"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M8.76711 3.95442C13.1748 0.00627004 24.8522 -0.0540889 30.3688 0.0123979C35.8852 0.0791912 45.1025 2.79565 48.7384 7.78646C52.316 12.6964 57.2237 21.0314 57.6807 27.5125C58.0151 32.2588 58.5457 38.7773 56.4932 42.9408C54.3007 47.3884 48.4395 52.8587 44.9725 55.1349C38.1522 59.6122 16.4116 55.2832 9.96313 50.0032C-2.54028 39.7651 -3.64987 15.0773 8.76711 3.95442Z"
							fill="#201F57"
						/>
					</svg>
				</div>
			</div>
		</div>
	);
};
